export const DEFAULT_LOCALE = 'en';
export const PAYMENT_STATUS_POLLING_MS = 2_000;
export const TIMER_SECONDS = 15 * 60;
export const REDIRECT_DELAY_MS = 3_000;
